import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Table from "../../Common/Table";

import TableFields from "../../../constants/Roles/TableFields.json";
import commonStyles from "../../../static/styles/common";

const useStyles = makeStyles((theme) => ({
  ...commonStyles.tableListStyles,
  table: {
    padding: theme.spacing(30),
  },
}));

const RolesList = (props) => {
  const classes = useStyles();
  const { handleClick, rolesList } = props;

  const getFieldValue = (item, key) => {
    switch (key) {
      case "actions":
        return (
          <span
            onClick={() => handleClick("Edit", item)}
            className={"edit-options cursor-pointer"}
          >
            View/Edit
          </span>
        );
      default:
        return item[key];
    }
  };
  return (
    <Table
      list={rolesList}
      getFieldValue={getFieldValue}
      fields={TableFields}
    />
  );
};

export default RolesList;
